const leasingData = {
  data: null,

  setData (json) {
    this.data = json
  },

  getProducts () {
    return Object.keys(this.data?.productsAndAssets ?? {})
  },

  getAssets (productKey) {
    return this.data?.productsAndAssets?.[productKey] ?? []
  },

  getAsset (productKey, assetName) {
    const assets = this.getAssets(productKey)
    return assets.find(asset => asset.assetName === assetName) || null
  },

  getMonthsAndFactors (productKey, assetName) {
    const asset = this.getAsset(productKey, assetName)
    return asset?.monthsAndFactors || null
  },

  getAvailableMonths (productKey, assetName) {
    const monthsAndFactors = this.getMonthsAndFactors(productKey, assetName)
    return monthsAndFactors ? Object.keys(monthsAndFactors).map(Number).sort((a, b) => a - b) : []
  },

  getLabels () {
    return this.data?.labels ?? {}
  },

  getLabel (key) {
    return this.data?.labels?.[key] ?? ''
  },

  getLocale () {
    return this.data?.locale || 'de-DE'
  },

  getCurrency () {
    return this.data?.currency || 'EUR'
  },

  getShowModalFlag () {
    return this.data?.showModalAndInfo === true
  },

  getShowRate () {
    return this.data?.showRate === true
  },

  getFormula (productKey, assetName) {
    const asset = this.getAsset(productKey, assetName)
    return asset?.formula || null
  }
}

export default leasingData
